import { Stack, Tooltip, Typography } from "@mui/material";
import { ITEM_TYPES } from "src/config/constants/genericConstants";
import useItemTypes from "src/hooks/useItemTypes";
import { GoBadgeGroup } from "../GoBadge";
import { tableCellArrowSx, tableCellTooltipSx } from "./style";

const DescriptionWithBadge = ({
  rowData,
  id
}: {
  rowData: any;
  id: string | number;
}) => {
  const itemTypes = useItemTypes({
    isCore:
      rowData?.tags?.includes(ITEM_TYPES.CORE) ||
      rowData?.tags?.includes(ITEM_TYPES.CORE_ITEM)
  });

  return (
    <Stack direction="column" spacing={1}>
      <Tooltip
        title={rowData[id]}
        placement="bottom-start"
        slotProps={{
          tooltip: { sx: tableCellTooltipSx },
          arrow: { sx: tableCellArrowSx }
        }}
        arrow
      >
        <Typography
          variant="subtitle2"
          color="grey.900"
          fontWeight={"normal"}
          data-testid="description-text"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
            cursor: "pointer"
          }}
        >
          {rowData[id]}
        </Typography>
      </Tooltip>
      <GoBadgeGroup
        badgeIds={itemTypes}
        parentSx={{ marginTop: "0px !important" }}
        sx={{
          padding: "2px 4px",
          height: "15px",
          lineHeight: "19px",
          display: "flex",
          alignItems: "center",
          letterSpacing: "0",
          fontSize: "10px",
          fontWeight: "600"
        }}
      />
    </Stack>
  );
};

export default DescriptionWithBadge;
